import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const RightFlex = styled(Flex)`
  gap: 25px;
`
export const LeftFlex = styled(Flex)`
  gap: 20px;
`
export const DetailsTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  margin: 20px 0;
  color: ${COLORS.GREY_T_20};
`
export const DetailsNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_50_2};
  flex: 0.3;
`
export const ContentDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  flex: 0.8;
  text-overflow: ellipsis;
  text-transform: ${props => !props?.noCap && 'capitalize'};
`
export const LinkSpan = styled.a`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.PRIMARY};
`
export const CollageNameFlex = styled(Flex)`
  flex-direction: column;
  gap: 5px;
  margin-left: 10px;
`
export const CollegeNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  color: ${COLORS.GREY_T_30};
`
export const CollegeCity = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_60};
`
export const CollageDetailsFlex = styled(Flex)`
  line-height: normal;
  width: 100%;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 15px;
`
export const InterviwerFlex = styled(Flex)`
  width: 100%;
`
export const MainFlex = styled(Flex)`
  gap: 15px;
`
export const AdjustIcon = styled.div`
  margin-top: 37px;
`
